import { IS_IBG_MANAGER } from "@/consts";

export default () => {
  if (IS_IBG_MANAGER) {
    return 400;
  }

  return 2000;
};
